import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Footer, GuestHeader } from "@/components";
import { env } from "@/env";

const PostPurchaseLayout = () => {
  return (
    <div className="flex min-h-dvh flex-col justify-between bg-canvas">
      <GuestHeader logoRedirectUrl={env.VITE_SHOPIFY_DOMAIN} />
      <Outlet />
      <Footer logoRedirectUrl={env.VITE_SHOPIFY_DOMAIN} />
    </div>
  );
};

export const Route = createFileRoute("/_guest/post-purchase")({
  component: PostPurchaseLayout,
});
